<template>
<div >
  <div class="page-footer">
    <p class="footerp footer-title"> {{ activeProfile.name }} </p>
          <p class="footerp"> {{ activeProfile.address }}</p>
          <p class="footerp"> Tel: {{ activeProfile.telephone }} </p>
          <p class="footerp"> Web: {{ activeProfile.website }} | Email: {{ activeProfile.email }} </p>
  </div>

<table class="print-table">

<tbody class="print-body">
  <tr >
    <td class="print-body-td" >

  <div class="print-paper">
  <div >
    <img class="logo" :src="activeProfile.logo || 'invoice_logo.png'" height="100px"/>
    <h1 class="header"> Invoice </h1>
  </div>

  <div class="clear"></div>

  <div >
    <div class="customer-info" v-if="selectedCustomer!=null"> 
      <p>Customer Reference: {{selectedCustomer.id}} </p>
      <p>{{selectedCustomer.name}}</p> 
      <p>{{selectedCustomer.email}}</p>
      <p>{{selectedCustomer.address}}</p>              
      <p>{{selectedCustomer.city&&selectedCustomer.city.name}}</p>    
      <p>{{selectedCustomer.postCode}} </p>    
      <p>Tel: {{selectedCustomer.contactNumber}} </p>          
    </div>

      <table class="invoice-info" v-if="this.invoice!=null&&selectedCustomer!=null">
        <tr><td class="invoice-info-col-label"> Invoice No: </td> <td class="invoice-info-col-value"> {{this.invoice.id}} </td> </tr>  
        <tr><td class="invoice-info-col-label"> Invoice Date: </td> <td class="invoice-info-col-value"> {{this.invoice.createdAt}} </td> </tr>  
        <tr><td class="invoice-info-col-label"> Client No: </td> <td class="invoice-info-col-value"> {{selectedCustomer.id}} </td> </tr>  
        <tr><td class="invoice-info-col-label"> PNR: </td> <td class="invoice-info-col-value"> {{this.invoice.locator}} </td> </tr>  
        <tr><td class="invoice-info-col-label"> Airline PNR: </td> <td class="invoice-info-col-value"> {{this.invoice.vendLoc}} </td> </tr>  
        <tr><td class="invoice-info-col-label"> Sector: </td> <td class="invoice-info-col-value"> N/A </td> </tr>  
        <tr><td class="invoice-info-col-label"> Served By: </td> <td class="invoice-info-col-value"> {{this.invoiceCreator}} </td> </tr>  
      </table>    

  </div>

  <div class="clear"></div>

  <hr />

  <table class="passengers-container" v-if="this.invoice!=null">
    <tr>
    <td class="passengers-label">
        Passengers
    </td>
    <td>
      <p v-for="passenger in this.invoice.passengers" :key="passenger.id">
          {{passenger.name}}
      </p>          
    </td>
    </tr>
  </table>

  <hr />

  <div class="flight-container" v-if="this.invoice!=null">
      <p class="flight-info-label"> FLIGHT INFORMATION </p> 
      <table>
        <tr class="border_bottom">
          <td> A/L </td>
          <td> FLIGHT </td>
          <td> FLT DATE </td>
          <td> FLT CLASS </td>
          <td> FLY FROM </td>
          <td> FLY TO </td>
          <td> DEPT TIME </td>
          <td> ARR TIME </td>
          <td> STATUS </td>
        </tr>      
        <tr class="flight" v-for="flight in this.invoice.flights" :key="flight.id">
          <td> {{flight.airline}} </td>
          <td> {{flight.flightNumber}} </td>
          <td> {{flight.flightDate.split("T")[0]}} </td>
          <td> {{flight.flightClass}} </td>
          <td> {{flight.flyFrom}} </td>
          <td> {{flight.flyTo}} </td>
          <td> {{flight.departureTime}} </td>
          <td> {{flight.airTime}} </td>
          <td> {{flight.status}} </td>
        </tr>          
      </table>
  </div>

  <hr />

  <div class="sale-desc" v-if="this.invoice!=null">
    <div class="sale-desc-header"> 
      <div class="sale-desc-label">
        SALE DESCRIPTION
      </div>
      <div class="sale-desc-ticket">
        TICKET PRICE
      </div>
    </div>
      
    <div v-for="passenger in this.invoice.passengers" :key="'tick'+passenger.ticketNumber" class="sale-desc-row"> 
    <div>
      <div class="sale-desc-label">
        Ticket # {{passenger.ticketNumber}} for {{passenger.name}}
      </div>
      <div class="sale-desc-ticket">
        {{parseFloat(passenger.gross).toFixed(2)}}
      </div>
    </div>
    <div class="clear"></div>    
    </div>
    <div class="clear"></div>

    <div class="sale-table">
      <table>
        <tr class="sale-table-row">
          <td> Gross Total: </td>
          <td>  £ </td>
          <td>  {{totalGrossAmount.toFixed(2)}} </td>
        </tr>
        <tr class="sale-table-row">
          <td> ATOL Charges: </td>
          <td>  £ </td>
          <td>  {{this.invoice.aToL.toFixed(2)}} </td>
        </tr>
        <tr class="sale-table-row">
          <td> Additional Charges: </td>
          <td>  £ </td>
          <td>  {{this.additionalCharges.toFixed(2)}} </td>
        </tr>
        <tr class="sale-table-row">
          <td> Discount: </td>
          <td>  £ </td>
          <td>  {{this.invoice.discount}} </td>
        </tr>
      </table>
    </div>
    
    <div class="clear"></div>

    <div class="total-table">
      <table>
        <tr class="sale-table-row">
          <td>  Invoice Total: </td>
          <td>  £ </td>
          <td>  {{this.invoiceTotal.toFixed(2)}} </td>
        </tr>
        <tr class="sale-table-row">
          <td> Payment Received: </td>
          <td>  £ </td>
          <td>  {{this.paymentReceived.toFixed(2)}} </td>
        </tr>
      </table>
    </div>

    <div class="clear"></div>

    <div class="total-table">
      <table>
        <tr class="sale-table-row">
          <td>  Balance Due: </td>
          <td>  £ </td>
          <td>  {{(this.totalGrossAmount-this.paymentReceived).toFixed(2)}} </td>
        </tr>
        
      </table>
    </div>

  </div>

  <div class="clear"></div>

  <div class="financial-container" v-if="this.invoice">
      <p class="financial-info-label"> FINANCIAL TRANSACTIONS </p> 
      <table>
        <tr class="border_bottom">
          <td> RECEIPT ID </td>
          <td> TRANS DATE </td>
          <td> PAY METHOD </td>
          <td> C OR D </td>
          <td> Amount </td>
        </tr>      
        <tr class="flight" v-for="invoicePayment in this.invoice.invoicePayments" :key="'payment'+invoicePayment.id">
          
          <td> {{invoicePayment.accountTransactionId}} </td>
          <td> {{invoicePayment.accountTransaction.createdAt.split("T")[0]}} </td>
          <td> {{paymentMethod(invoicePayment.accountTransaction)}} </td>
          <td> {{invoicePayment.accountTransaction.amountCredit>0?'CR':'DB'}} </td>
          <td> {{invoicePayment.accountTransaction.amountCredit>0?invoicePayment.accountTransaction.amountCredit.toFixed(2):invoicePayment.accountTransaction.amountDebit.toFixed(2)}} </td>          
        </tr>             
      </table>
  </div>
  </div>
</td>
  </tr>
</tbody>

<tfoot >
    <tr>
      <td>
        <div class="page-footer-space"></div>          
      </td>
    </tr>
  </tfoot>

</table>
</div>
</template>

<style  scoped>
table {
    font-family:Verdana, Geneva, Tahoma, sans-serif; 
}

p {
    font-family:Verdana, Geneva, Tahoma, sans-serif; 
}

td {
    font-family:Verdana, Geneva, Tahoma, sans-serif; 
}
.print-table {
    height:100%;
    width:100%;
}
.print-paper{
    font-family:Verdana, Geneva, Tahoma, sans-serif; 
    font-size: 1.2em;
    margin: 0em;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    color-adjust: exact !important;
    line-height: 0.5;
    border-collapse: collapse;        
  }
  .clear {
    float: none;
    clear: both;
  }
  .logo {
    padding-top: 50px;
    float: left;
  }
  .header {
    text-align: center;
    width: 50%;
    padding-top: 50px;
    float: right;  
  }
  .customer-info {  
    float: left;
    padding: 10px;
    padding-left: 20px;
    padding-top: 20px;
    width:400px;
    border-radius: 25px;
    background-color: lightgray;
  }
  
  .invoice-info {      
    float: right;  
    line-height: 1.2;
    padding-right:250px;  
    padding-left: 20px;
  }
  
  .invoice-info-col-label { 
    text-align: right;;  
  } 
  
  .invoice-info-col-value { 
  
    text-align: left;    
    padding-left: 20px;
  }
  
  hr { width:100%; height:4px;margin-top: 15px; background: black }
  
  .passengers-label {
    float: left;
    height:100px;
    margin-left: 20px;
    margin-right: 50px;  
    font-weight: bold;
  }
  
  .passengers-container {
    margin-top:30px;
  }
  
  .flight-container {
    margin-top:20px;
  }
  
  .flight-info-label { 
    border-radius: 4px;
    background-color: lightgray;
    font-weight: bold;  
    padding:10px;
  }
  
  tr.border_bottom td {
    padding-bottom: 10px;
    border-bottom: 2px solid black;
    width: 200px;
  }
  tr.flight {  
    height:30px
  }
  
  .sale-desc {
    margin-top:30px
  }
  
  .sale-desc-label {
    float:left;
  }
  
  .sale-desc-ticket {
    float:right;    
    padding-right:50px;
  }
  
  .sale-desc-header {
    padding-bottom: 20px;
    border-bottom: 2px solid black;
  }
  
  .sale-desc-row {
    margin-top:20px
  }
  
  .sale-table {
    float:right;
    margin-top:40px;
    border-bottom: 2px solid black;
  }
  
  tr.sale-table-row td {
    text-align: right;
    padding-bottom: 10px;  
    width: 250px;
    padding-right:50px;
  }
  .sale-table-row {  
    height:30px
  }
  
  
  .total-table {
    font-weight: bold;
    float:right;
    margin-top:10px;
    border-bottom: 2px solid black;
  }
  
  .financial-container {
    margin:20px
  }
  
  .financial-info-label {
    width:1024px;
    border-radius: 4px;
    background-color: lightgray;
    font-weight: bold;  
    padding:10px;
  }
  
  .footerp {  
    margin: 0px !important;
    text-align: center;    
  }
  
  .footer-title {
    padding-top:10px;
    font-weight: bolder;
    text-align: center;
  }



table td {
    vertical-align:top
}

tfoot {
    display: table-footer-group;
}



@media print {
  thead {display: table-header-group;} 
  tfoot {display: table-footer-group;}
  
  button {display: none;}
  
  body {margin: 0;}
}


.page-footer, .page-footer-space {
  height: 100px;

}

.page-footer {
  position: fixed;
  bottom: 0;
  width: 100%;  
}

</style>

<script>
import { mapState } from 'vuex'
import _ from 'lodash';
  export default {
    name: 'PrintInvoice',
    data: () => ({
    }),
    methods: {
      paymentMethod(payment) {
        if (payment.cash>0)
          return "CASH"
        else if (payment.cheque>0)
          return "CHEQUE"
        else if (payment.card>0)
          return "CARD"
        else if (payment.bankDeposit>0)
        return "BANK DEPOSIT"  
          
        return "N/A";
      }
    },
    computed: {
      ...mapState('invoice', ['selectedInvoice','newInvoice']),
      ...mapState('customers', ['selectedCustomer']), 
      ...mapState('account', ['user']),
      activeProfile() {
        return this.$store.getters['companyProfiles/activeProfile'];
      },
      totalNetAmount() {
        let sum = _.sumBy(this.invoice.passengers, function (passenger) {
          return passenger.netPrice; 
        });
        return sum;
      },
      totalGrossAmount() {
        let sum = _.sumBy(this.invoice.passengers, function (passenger) {
          return passenger.gross; 
        });
        return parseFloat(sum);
      },
      invoice() {        
        return this.selectedInvoice;
      },
      additionalCharges() {        
        return 0;
      },
      invoiceTotal() {
        return this.additionalCharges+this.totalGrossAmount+this.invoice.aToL;
      },      
      invoiceCreator() {
        if (this.invoice.User) {
          return this.invoice.User.name;
        }        
        else {
          return this.user.name;
        }
      },
      paymentReceived() {        
        let sum = _.sumBy(this.invoice.invoicePayments, function (invoicePayment) {
          if (invoicePayment.amountCredit>0)
            return invoicePayment.amountCredit;
          else
            return -(invoicePayment.amountDebit);
        });
        return sum;
      }      
    }  
  }
</script>